import _objectSpread from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john/workspace/test/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var PhoneComLoginCenterClient = /*#__PURE__*/function () {
  function PhoneComLoginCenterClient(clientId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, PhoneComLoginCenterClient);
    this._initOptions(_objectSpread({
      clientId: clientId
    }, options));
    this._$iframe = null;
    this._initEventsListener();
  }
  _createClass(PhoneComLoginCenterClient, [{
    key: "_initOptions",
    value: function _initOptions(options) {
      this._options = {
        stage: 'prod',
        webUrl: 'https://accounts.phone.com',
        clientId: null,
        redirectUri: document && document.location ? "".concat(document.location.protocol, "//").concat(document.location.host) : '',
        scope: null,
        returnToken: true,
        opedId: true,
        autoUnload: true,
        width: 500,
        minHeight: 150,
        widgetOptions: {},
        callbackSuccess: function callbackSuccess(data, mode) {
          console.warn('"callbackSuccess" is not defined', data, mode);
        }
      };
      this.setOptions(options);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var WEBURLS = {
        'stage': 'https://oauth-stage.cit-phone.com',
        'dev': 'https://oauth-pcdev.cit-phone.com',
        'preprod': 'https://accounts-pp.cit-phone.com',
        'prod': 'https://accounts.phone.com'
      };
      if (!options.webUrl && options.stage && WEBURLS[options.stage]) {
        options.webUrl = WEBURLS[options.stage];
      }
      Object.assign(this._options, options);
      return this;
    }
  }, {
    key: "setOption",
    value: function setOption(name, value) {
      this._options[name] = value;
      return this;
    }
  }, {
    key: "_buildRequest",
    value: function _buildRequest() {
      if (!this._options.clientId) {
        throw new Error('Client ID is not configured');
      }
      if (!this._options.redirectUri) {
        throw new Error('Redirect URI is not configured');
      }
      var q = new URLSearchParams({
        client_id: this._options.clientId,
        redirect_uri: this._options.redirectUri,
        response_type: "".concat(this._options.opedId ? 'id_token ' : '').concat(this._options.returnToken ? 'token' : 'code'),
        widget: btoa(JSON.stringify(this._options.widgetOptions))
      });
      if (this._options.windowed) {
        this._options.autoUnload = false;
        q.set('windowed', 1);
        q.delete('widget');
      }
      if (this._options.scope) {
        q.set('scope', this._options.scope);
      }
      return q;
    }
  }, {
    key: "open",
    value: function open() {
      window.open("".concat(this._options.webUrl, "/?").concat(this._buildRequest().toString()), 'signin', "popup,left=100,top=100,width=450,height=640");
    }
  }, {
    key: "_createIFrame",
    value: function _createIFrame() {
      this._$iframe = document.createElement('iframe');
      this._$iframe.setAttribute('src', "".concat(this._options.webUrl, "/?").concat(this._buildRequest().toString()));
      this._$iframe.setAttribute('width', this._options.width.toString());
      this._$iframe.setAttribute('height', this._options.minHeight.toString());
      this._$iframe.setAttribute('style', 'border: none');
      this._$iframe.textContent = "Iframes aren't supported by your browser";
    }
  }, {
    key: "_initEventsListener",
    value: function _initEventsListener() {
      var _this = this;
      window.addEventListener('message', function (e) {
        if (e.origin !== _this._options.webUrl) {
          console.debug('PDC Authorization origin mismatch', e.origin, _this._options.webUrl);
          return;
        }
        if (e.data.event === 'sign-in') {
          if (_this._options.autoUnload) {
            _this.unload();
          }
          _this._options.callbackSuccess(e.data.data, e.data.mode || 'default');
        } else if (e.data.event === 'resize') {
          _this._$iframe.setAttribute('height', Math.max(_this._options.minHeight, e.data.data.height).toString());
        }
      });
    }
  }, {
    key: "render",
    value: function render(containerId) {
      var $container = document.getElementById(containerId);
      if (!$container) {
        throw new Error("Element with ID \"".concat(containerId, "\" is not found"));
      }
      if (this._$iframe) {
        this.unload();
      }
      this._createIFrame();
      $container.appendChild(this._$iframe);
    }
  }, {
    key: "unload",
    value: function unload() {
      if (!this._$iframe) {
        throw new Error('IFrame not found');
      }
      this._$iframe.remove();
    }
  }]);
  return PhoneComLoginCenterClient;
}();
if (window) {
  window.PhoneComLoginCenterClient = PhoneComLoginCenterClient;
}
export default PhoneComLoginCenterClient;